import { Box, Button, Flex } from '@chakra-ui/react';
import { useEffect } from 'react';

import Dialog from '@app/components/common/modals/dialog';
import { SelectField, TextField } from '@app/components/common';
import { useAlert, useEntityState } from '@app/hooks';

import { SalesSource } from '../types';

export const SalesSourceDialog = ({
  isVisible,
  salesSources,
  item,
  onClose,
  onSave,
}: {
  isVisible: boolean;
  salesSources: EntityBase[];
  item: SalesSource | undefined;
  onClose: () => void;
  onSave: (item: SalesSource) => void;
}) => {
  const [instance, onChange, setInstance] = useEntityState<SalesSource>(item);
  const { error } = useAlert();

  useEffect(() => {
    setInstance(item);
  }, [item]);

  const onSaveClick = () => {
    if (!instance.source) {
      error('Выберите источник продаж');
      return;
    }
    if (!instance.sales_outlet_id) {
      error('Введите ID ТТ источника продаж');
      return;
    }

    onSave({
      sales_outlet_id: instance.sales_outlet_id,
      source: instance.source,
    });
    setInstance(undefined);
    onClose();
  };

  return <Dialog  
    open={isVisible}
    title="Источник продаж"
    onClose={onClose}
    actions={<Flex justifyContent='space-between' w='100%'>
      <Button onClick={onSaveClick} variant='solid' colorScheme="brand">Сохранить</Button>
      <Button onClick={onClose}>Отмена</Button>
    </Flex>}
  >
    <Flex gap={4} alignItems='center' direction='column'>
      <SelectField
        required
        options={salesSources}
        value={instance.source}
        onChange={(value) => {
          onChange('source')(value);
        } } 
        id="source"      
        label="Источник продаж"
      />
      <TextField
        required
        value={instance?.sales_outlet_id?.toString()}
        onChange={(value) => {
          onChange('sales_outlet_id')(value);
        } } 
        id="sales_outlet_id"      
        label="ID ТТ источника продаж"
      />
    </Flex>
  </Dialog> 
  ;
};